import React, { SVGProps } from 'react'

export enum ChevronDirection {
  down = 'rotate(0)',
  up = 'rotate(180)',
  left = 'rotate(90)',
  right = 'rotate(270)',
}

interface Props extends SVGProps<SVGSVGElement> {
  /** Used for making bundle optimised icons */
  groupTransform?: string
}

const ChevronDownIcon = ({ groupTransform, ...props }: Props) => (
  <svg
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    aria-hidden="true"
    {...props}
  >
    <g transform={groupTransform} transform-origin="center">
      <path
        d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export default ChevronDownIcon
